import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/slices/auth.slice";

import ProfileBanner from "./ProfileBanner";
import { serverUrl } from "../../nestserver";

function ParentMainProfile() {
  const user = useSelector(selectUser);

  return (
    <ProfileBanner
      userId={user?._id}
      roleData={user?.parent}
      patchUrl={serverUrl + "/parent/" + user?.parent?._id}
    />
  );
}

export default ParentMainProfile;
